import { useEffect, useState } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Loader from './components/Loader/Loader';
import Home from './pages/Home';

function App() {

const [loading, setLoading] = useState(true);
const [isMoon, setIsMoon] = useState(true);

let htmlClasses = document.querySelector("html").classList;

// Maintain state for theme
useEffect(() => {
if (localStorage.theme === "dark") {
  htmlClasses.add("dark");
  setIsMoon(false);
}
}, [htmlClasses]);


const toggleDarkMode = () => {
  if (localStorage.theme === "dark") {
    htmlClasses.remove("dark");
    localStorage.removeItem("theme");
    setIsMoon(true);
  } 
  else {
    htmlClasses.add("dark");
    localStorage.setItem("theme", "dark");
    setIsMoon(false);
  }
};

if (loading) {
  setTimeout(() => {
    setLoading(false);
  }, 4000);
}


  return (
    loading? <Loader/> :
    <>
      <BrowserRouter>
            <Routes>
                <Route path="/" element={<Home toggleDarkMode={toggleDarkMode} isMoon={isMoon}/>} />
            </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
